import { IconCheckDefault, IconExclamationTriangleFilled } from '@iwoca/icons';
import { AlertBox } from '@iwoca/orion';

import styles from './DocumentRequirementStep.module.css';
import { Button } from '../../../Button/Button';

type TProps = {
  stepNumber: number;
  title: string;
  isComplete?: boolean;
  isActive?: boolean;
  isError?: boolean;
  isLastStep?: boolean;
  errorMessage?: string;
  showDirectUpload?: boolean;
  onContinue?: () => void;
  onUploadFurther?: () => void;
  children: (props: {
    isActive: boolean;
    isError: boolean;
    onRequestUpload: () => void;
    showDirectUpload: boolean;
  }) => React.ReactNode;
};

const DocumentRequirementStep = ({
  stepNumber,
  title,
  isComplete = false,
  isActive = false,
  isError = false,
  isLastStep = false,
  errorMessage,
  showDirectUpload = false,
  onContinue,
  onUploadFurther,
  children,
}: TProps) => {
  const handleRequestUpload = () => {
    onUploadFurther?.();
  };
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          {isComplete && (
            <IconCheckDefault
              width={20}
              height={20}
              className={styles.checkIcon}
              data-testid="step-complete-icon"
            />
          )}
          <h3 className={styles.title}>
            <span className={styles.stepNumber}>{stepNumber}.</span> {title}
          </h3>
        </div>
      </div>
      <div className={styles.content}>
        {children({
          isActive,
          isError,
          onRequestUpload: handleRequestUpload,
          showDirectUpload,
        })}
        {isError && errorMessage && !isComplete && (
          <AlertBox variant="failure" className={styles.errorMessage}>
            <IconExclamationTriangleFilled className={styles.errorIcon} />
            {errorMessage}
          </AlertBox>
        )}
        {isActive && onContinue && (
          <Button className={styles.continueButton} onClick={onContinue}>
            {isLastStep ? 'Continue to summary' : 'Continue to next step'}
          </Button>
        )}
      </div>
    </div>
  );
};

export default DocumentRequirementStep;
